var FALLBACK_DELAY, MAX_MOUSE_LOCS, documentListener, getSlope, mouseLocs, mousemoveDocument, noop;

MAX_MOUSE_LOCS = 3;

FALLBACK_DELAY = 300;

mouseLocs = [];

documentListener = null;

noop = function() {};

mousemoveDocument = function(e) {
  mouseLocs.push({
    x: e.pageX,
    y: e.pageY
  });
  if (mouseLocs.length > MAX_MOUSE_LOCS) {
    return mouseLocs.shift();
  }
};

getSlope = function(pointA, pointB) {
  return (pointB.y - pointA.y) / (pointB.x - pointA.x);
};


/*
 * Return instance of flyout with triangle algorithm
 *
 * @param   {Object} [options]
 * @returns {Object} - instance of flyout with activateRow and deactivateRow methods
 */

module.exports = function(options) {
  var $menuElem, activateRow, activateRowTimeout, activeRow, clearExistingTimeout, deactivateRow, delay, getActivationDelay, lastDelayLoc, mouseenterRow, mouseleaveMenu, onActivateRow, onDeactivateRow, possiblyActivateRow, rowSelector;
  $menuElem = options.$menuElem, rowSelector = options.rowSelector, delay = options.delay, onActivateRow = options.onActivateRow, onDeactivateRow = options.onDeactivateRow;
  if (!($menuElem != null ? $menuElem.find(rowSelector).length : void 0)) {
    return;
  }
  if (onActivateRow == null) {
    onActivateRow = noop;
  }
  if (onDeactivateRow == null) {
    onDeactivateRow = noop;
  }
  activeRow = null;
  activateRowTimeout = null;
  lastDelayLoc = null;
  if (delay == null) {
    delay = FALLBACK_DELAY;
  }
  mouseleaveMenu = clearExistingTimeout = function() {
    if (activateRowTimeout) {
      return clearTimeout(activateRowTimeout);
    }
  };

  /*
   * Set active row within a menu
   *
   * @param   {Object} - jQuery row elem to set active within a flyout instance
   * @returns {Object} - jQuery row elem that is now active
   */
  activateRow = function(newActiveRow) {
    if (newActiveRow === activeRow) {
      return;
    }
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    onActivateRow(newActiveRow);
    return activeRow = newActiveRow;
  };

  /*
   * Deactivate current active row
   *
   * @returns {null}
   */
  deactivateRow = function() {
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    return activeRow = null;
  };
  getActivationDelay = function() {
    var currentLoc, decreasingSlope, increasingSlope, menuBottomRight, menuUpperRight, offset, prevDecreasingSlope, prevIncreasingSlope, prevLoc;
    if (!activeRow) {
      return 0;
    }
    offset = $menuElem.offset();
    menuUpperRight = {
      x: offset.left + $menuElem.outerWidth(),
      y: offset.top - 75
    };
    menuBottomRight = {
      x: menuUpperRight.x,
      y: offset.top + $menuElem.outerHeight() + 75
    };
    if ((currentLoc = mouseLocs[mouseLocs.length - 1]) == null) {
      return 0;
    }
    prevLoc = mouseLocs[0];
    if (prevLoc.x < offset.left || prevLoc.x > menuBottomRight.x || prevLoc.y < offset.top || prevLoc.y > menuBottomRight.y) {
      return 0;
    }
    if (lastDelayLoc && currentLoc.x === lastDelayLoc.x && currentLoc.y === lastDelayLoc.y) {
      return 0;
    }
    decreasingSlope = getSlope(currentLoc, menuUpperRight);
    increasingSlope = getSlope(currentLoc, menuBottomRight);
    prevDecreasingSlope = getSlope(prevLoc, menuUpperRight);
    prevIncreasingSlope = getSlope(prevLoc, menuBottomRight);
    if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
      lastDelayLoc = currentLoc;
      return delay;
    } else {
      lastDelayLoc = null;
      return 0;
    }
  };
  possiblyActivateRow = function(rowElem) {
    var activationDelay;
    activationDelay = getActivationDelay();
    if (activationDelay) {
      return activateRowTimeout = setTimeout((function() {
        return possiblyActivateRow(rowElem);
      }), activationDelay);
    } else {
      return activateRow(rowElem);
    }
  };
  mouseenterRow = function() {
    clearExistingTimeout();
    return possiblyActivateRow(this);
  };
  $menuElem.on('mouseleave', mouseleaveMenu).find(rowSelector).on('mouseenter', mouseenterRow);
  if (documentListener == null) {
    documentListener = $(document).on('mousemove', mousemoveDocument);
  }
  return {
    activateRow: activateRow,
    deactivateRow: deactivateRow
  };
};

//# sourceMappingURL=data:application/json;base64,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
